var FALLBACK_DELAY, MAX_MOUSE_LOCS, documentListener, getSlope, mouseLocs, mousemoveDocument, noop;

MAX_MOUSE_LOCS = 3;

FALLBACK_DELAY = 300;

mouseLocs = [];

documentListener = null;

noop = function() {};

mousemoveDocument = function(e) {
  mouseLocs.push({
    x: e.pageX,
    y: e.pageY
  });
  if (mouseLocs.length > MAX_MOUSE_LOCS) {
    return mouseLocs.shift();
  }
};

getSlope = function(pointA, pointB) {
  return (pointB.y - pointA.y) / (pointB.x - pointA.x);
};


/*
 * Return instance of flyout with triangle algorithm
 *
 * @param   {Object} [options]
 * @returns {Object} - instance of flyout with activateRow and deactivateRow methods
 */

module.exports = function(options) {
  var $menuElem, activateRow, activateRowTimeout, activeRow, clearExistingTimeout, deactivateRow, delay, getActivationDelay, lastDelayLoc, mouseenterRow, mouseleaveMenu, onActivateRow, onDeactivateRow, possiblyActivateRow, rowSelector;
  $menuElem = options.$menuElem, rowSelector = options.rowSelector, delay = options.delay, onActivateRow = options.onActivateRow, onDeactivateRow = options.onDeactivateRow;
  if (!($menuElem != null ? $menuElem.find(rowSelector).length : void 0)) {
    return;
  }
  if (onActivateRow == null) {
    onActivateRow = noop;
  }
  if (onDeactivateRow == null) {
    onDeactivateRow = noop;
  }
  activeRow = null;
  activateRowTimeout = null;
  lastDelayLoc = null;
  if (delay == null) {
    delay = FALLBACK_DELAY;
  }
  mouseleaveMenu = clearExistingTimeout = function() {
    if (activateRowTimeout) {
      return clearTimeout(activateRowTimeout);
    }
  };

  /*
   * Set active row within a menu
   *
   * @param   {Object} - jQuery row elem to set active within a flyout instance
   * @returns {Object} - jQuery row elem that is now active
   */
  activateRow = function(newActiveRow) {
    if (newActiveRow === activeRow) {
      return;
    }
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    onActivateRow(newActiveRow);
    return activeRow = newActiveRow;
  };

  /*
   * Deactivate current active row
   *
   * @returns {null}
   */
  deactivateRow = function() {
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    return activeRow = null;
  };
  getActivationDelay = function() {
    var currentLoc, decreasingSlope, increasingSlope, menuBottomRight, menuUpperRight, offset, prevDecreasingSlope, prevIncreasingSlope, prevLoc;
    if (!activeRow) {
      return 0;
    }
    offset = $menuElem.offset();
    menuUpperRight = {
      x: offset.left + $menuElem.outerWidth(),
      y: offset.top - 75
    };
    menuBottomRight = {
      x: menuUpperRight.x,
      y: offset.top + $menuElem.outerHeight() + 75
    };
    if ((currentLoc = mouseLocs[mouseLocs.length - 1]) == null) {
      return 0;
    }
    prevLoc = mouseLocs[0];
    if (prevLoc.x < offset.left || prevLoc.x > menuBottomRight.x || prevLoc.y < offset.top || prevLoc.y > menuBottomRight.y) {
      return 0;
    }
    if (lastDelayLoc && currentLoc.x === lastDelayLoc.x && currentLoc.y === lastDelayLoc.y) {
      return 0;
    }
    decreasingSlope = getSlope(currentLoc, menuUpperRight);
    increasingSlope = getSlope(currentLoc, menuBottomRight);
    prevDecreasingSlope = getSlope(prevLoc, menuUpperRight);
    prevIncreasingSlope = getSlope(prevLoc, menuBottomRight);
    if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
      lastDelayLoc = currentLoc;
      return delay;
    } else {
      lastDelayLoc = null;
      return 0;
    }
  };
  possiblyActivateRow = function(rowElem) {
    var activationDelay;
    activationDelay = getActivationDelay();
    if (activationDelay) {
      return activateRowTimeout = setTimeout((function() {
        return possiblyActivateRow(rowElem);
      }), activationDelay);
    } else {
      return activateRow(rowElem);
    }
  };
  mouseenterRow = function() {
    clearExistingTimeout();
    return possiblyActivateRow(this);
  };
  $menuElem.on('mouseleave', mouseleaveMenu).find(rowSelector).on('mouseenter', mouseenterRow);
  if (documentListener == null) {
    documentListener = $(document).on('mousemove', mousemoveDocument);
  }
  return {
    activateRow: activateRow,
    deactivateRow: deactivateRow
  };
};

//# sourceMappingURL=data:application/json;base64,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
